var FALLBACK_DELAY, MAX_MOUSE_LOCS, documentListener, getSlope, mouseLocs, mousemoveDocument, noop;

MAX_MOUSE_LOCS = 3;

FALLBACK_DELAY = 300;

mouseLocs = [];

documentListener = null;

noop = function() {};

mousemoveDocument = function(e) {
  mouseLocs.push({
    x: e.pageX,
    y: e.pageY
  });
  if (mouseLocs.length > MAX_MOUSE_LOCS) {
    return mouseLocs.shift();
  }
};

getSlope = function(pointA, pointB) {
  return (pointB.y - pointA.y) / (pointB.x - pointA.x);
};


/*
 * Return instance of flyout with triangle algorithm
 *
 * @param   {Object} [options]
 * @returns {Object} - instance of flyout with activateRow and deactivateRow methods
 */

module.exports = function(options) {
  var $menuElem, activateRow, activateRowTimeout, activeRow, clearExistingTimeout, deactivateRow, delay, getActivationDelay, lastDelayLoc, mouseenterRow, mouseleaveMenu, onActivateRow, onDeactivateRow, possiblyActivateRow, rowSelector;
  $menuElem = options.$menuElem, rowSelector = options.rowSelector, delay = options.delay, onActivateRow = options.onActivateRow, onDeactivateRow = options.onDeactivateRow;
  if (!($menuElem != null ? $menuElem.find(rowSelector).length : void 0)) {
    return;
  }
  if (onActivateRow == null) {
    onActivateRow = noop;
  }
  if (onDeactivateRow == null) {
    onDeactivateRow = noop;
  }
  activeRow = null;
  activateRowTimeout = null;
  lastDelayLoc = null;
  if (delay == null) {
    delay = FALLBACK_DELAY;
  }
  mouseleaveMenu = clearExistingTimeout = function() {
    if (activateRowTimeout) {
      return clearTimeout(activateRowTimeout);
    }
  };

  /*
   * Set active row within a menu
   *
   * @param   {Object} - jQuery row elem to set active within a flyout instance
   * @returns {Object} - jQuery row elem that is now active
   */
  activateRow = function(newActiveRow) {
    if (newActiveRow === activeRow) {
      return;
    }
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    onActivateRow(newActiveRow);
    return activeRow = newActiveRow;
  };

  /*
   * Deactivate current active row
   *
   * @returns {null}
   */
  deactivateRow = function() {
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    return activeRow = null;
  };
  getActivationDelay = function() {
    var currentLoc, decreasingSlope, increasingSlope, menuBottomRight, menuUpperRight, offset, prevDecreasingSlope, prevIncreasingSlope, prevLoc;
    if (!activeRow) {
      return 0;
    }
    offset = $menuElem.offset();
    menuUpperRight = {
      x: offset.left + $menuElem.outerWidth(),
      y: offset.top - 75
    };
    menuBottomRight = {
      x: menuUpperRight.x,
      y: offset.top + $menuElem.outerHeight() + 75
    };
    if ((currentLoc = mouseLocs[mouseLocs.length - 1]) == null) {
      return 0;
    }
    prevLoc = mouseLocs[0];
    if (prevLoc.x < offset.left || prevLoc.x > menuBottomRight.x || prevLoc.y < offset.top || prevLoc.y > menuBottomRight.y) {
      return 0;
    }
    if (lastDelayLoc && currentLoc.x === lastDelayLoc.x && currentLoc.y === lastDelayLoc.y) {
      return 0;
    }
    decreasingSlope = getSlope(currentLoc, menuUpperRight);
    increasingSlope = getSlope(currentLoc, menuBottomRight);
    prevDecreasingSlope = getSlope(prevLoc, menuUpperRight);
    prevIncreasingSlope = getSlope(prevLoc, menuBottomRight);
    if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
      lastDelayLoc = currentLoc;
      return delay;
    } else {
      lastDelayLoc = null;
      return 0;
    }
  };
  possiblyActivateRow = function(rowElem) {
    var activationDelay;
    activationDelay = getActivationDelay();
    if (activationDelay) {
      return activateRowTimeout = setTimeout((function() {
        return possiblyActivateRow(rowElem);
      }), activationDelay);
    } else {
      return activateRow(rowElem);
    }
  };
  mouseenterRow = function() {
    clearExistingTimeout();
    return possiblyActivateRow(this);
  };
  $menuElem.on('mouseleave', mouseleaveMenu).find(rowSelector).on('mouseenter', mouseenterRow);
  if (documentListener == null) {
    documentListener = $(document).on('mousemove', mousemoveDocument);
  }
  return {
    activateRow: activateRow,
    deactivateRow: deactivateRow
  };
};

//# sourceMappingURL=data:application/json;base64,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
